import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Compass, ArrowRight } from "lucide-react";
import BrandMark from "../components/BrandMark";

export default function NotFound() {
  const location = useLocation();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 text-center" data-testid="not-found-page">
      <Link to="/" className="mb-8" aria-label="FlowFinder home">
        <BrandMark size={44} />
      </Link>
      <div className="label-mono text-white/45">404 · Not found</div>
      <h1 className="text-4xl sm:text-5xl text-white font-semibold tracking-tight mt-3 leading-tight">
        We can't find that page
      </h1>
      <p className="text-white/65 mt-3 max-w-md text-[15px]">
        The page <code className="font-mono text-white/85">{location.pathname}</code> doesn't exist
        or has moved. Try the scanner or head back home.
      </p>
      <div className="mt-7 flex flex-wrap items-center justify-center gap-2">
        <Link to="/" className="btn-ghost text-sm py-2 px-4 inline-flex items-center gap-2" data-testid="not-found-home">
          <Compass className="w-4 h-4" />
          Home
        </Link>
        <Link to="/dashboard" className="btn-accent text-sm py-2 px-4 inline-flex items-center gap-2" data-testid="not-found-dashboard">
          Open Scanner
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
}
